/*
_slider-small.js
Slides content via button

tobias.wolf@wagnerwagner.de
*/

(function () {
  function SliderSmall(element) {
    // elements
    const nextElement = element.querySelector('.slider-small__next');
    const containerElement = element.querySelector('.slider-small__container');
    const itemElements = containerElement.querySelectorAll('.ce_text');

    // variables
    let widthAndMarginOfItem = 0;
    let visibleElement = 1;
    let visibileElements = 1; // how many items are visible in container

    // functions
    function init() {
      if (itemElements.length > 1) {
        widthAndMarginOfItem = itemElements[1].offsetLeft;
        visibileElements = Math.floor((containerElement.offsetWidth + 32 * 3) / widthAndMarginOfItem);
        if (itemElements.length > visibileElements) {
          nextElement.classList.add('is-visible');
          element.classList.add('is-scrolling');
        }
      }
    }

    function scrollToFirst() {
      visibleElement = 1;
      const duration = 250 + ((visibileElements - 1) / 4) * 250;
      SCROLLING.scrollLeft(containerElement, 0, duration);
      convertToNextButton();
    }

    function scrollToNext() {
      const scrollLeft = itemElements[visibleElement].offsetLeft - 32; // 32 is padding-left of .slider-small__container
      SCROLLING.scrollLeft(containerElement, scrollLeft, 250);
      visibleElement++;
      if (visibleElement > itemElements.length - visibileElements) {
        convertToBackButton();
      }
    }

    function convertToBackButton() {
      nextElement.classList.add('slider-small__first');
      nextElement.classList.remove('slider-small__next');
    }

    function convertToNextButton() {
      nextElement.classList.add('slider-small__next');
      nextElement.classList.remove('slider-small__first');
    }

    function handleNextClick() {
      if (nextElement.classList.contains('slider-small__next')) {
        scrollToNext();
      } else {
        scrollToFirst();
      }
    }

    // event listener
    nextElement.addEventListener('click', handleNextClick);

    // init
    init();
  }

  // elements
  const elements = document.querySelectorAll('.slider-small');

  // init
  for (let i = 0; i < elements.length; i++) {
    new SliderSmall(elements[i]);
  }
}());
